import React, { Component } from 'react';
import { inject } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';

import { Section } from '../shared';

import SocialButtons from './SocialButtons';

import { minWidth } from '../../helpers/media-queries';

const styles = () => ({
    root: {
        '& .container': {
            display: 'flex',
            justifyContent: 'center',
            padding: 0,
        },
        [minWidth.xl]: {
            position: 'fixed',
            top: 0,
            height: '1px',
            background: 'transparent',
            width: '100%',
            padding: 0,
            '& .container': {
                height: '1px',
                position: 'relative',
                background: 'transparent',
                border: 0,
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-end'
            }
        }
    }
});

const mapper = () => ({})

class Social extends Component {
    render() {
        const { classes } = this.props;
        return (
            <Section className={classes.root} id="sesion-social">
                <SocialButtons />
            </Section>
        )
    }
}

export default inject(mapper)(
    withStyles(styles)(Social)
);